import Vue from 'vue'
import Vuex from 'vuex'
import Account from './account'
import Product from './product'
import Tenant from './tenant'
import Bill from './bill'
import Order from './order'
import Employee from './employee'
import DeliveryAgent from './deliveryAgent'
import SubProduct from './subProduct'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appLoading: false
  },
  mutations: {
    appLoading(state, payload) {
      state.appLoading = payload
    }
  },
  actions: {},
  modules: {
    account: Account,
    product: Product,
    tenant: Tenant,
    bill: Bill,
    order: Order,
    employee: Employee,
    deliveryAgent: DeliveryAgent,
    subProduct: SubProduct
  }
})
